/** YYYY-MM-DD for `<input type="date" />` */
export function getTodayIsoDate(): string {
  const t = new Date();
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, "0");
  const d = String(t.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Converts YYYY-MM-DD to MM-DD-YYYY for RoutesInformation admin APIs */
export function formatIsoDateToUsMdY(iso: string): string {
  const parts = iso.trim().split("-");
  if (parts.length !== 3) return "";
  const [y, m, d] = parts;
  if (!y || !m || !d) return "";
  return `${m}-${d}-${y}`;
}
